import * as React from 'react';
import { mergeStyleSets } from '@fluentui/react/lib/Styling';
import moment from 'moment-timezone';
import { formStyles } from 'styles/formStyles';
import { FilterValues } from './types';

export const styles = mergeStyleSets({
    filterInfo: {
        marginBottom: 10,
    },
});

interface FilterInfoProps {
    filterValues: FilterValues;
}

export const FilterInfo: React.FC<FilterInfoProps> = ({ filterValues: { sourceEntity } }) => {
    const sourceEntityLabel = sourceEntity === 'auftrag' ? 'Auftrag' : 'Rechnung';

    return (
        <table className={formStyles.reportFilterInfo}>
            <tr>
                <td>Druckdatum: </td>
                <td>{moment().format('DD.MM.YYYY HH:mm:ss')}</td>
            </tr>
            <tr>
                <td>Quelle::</td>
                <td>{sourceEntityLabel}</td>
            </tr>
        </table>
    );
};
